export const USER_PERMISSION = {
  VIEW_AVAILABILITY: 'urn:replicon:user-action:view-availability',
  EDIT_USER: 'urn:replicon:user-action:edit-user',
  EDIT_PREFERENCES: 'urn:replicon:user-action:edit-preferences',
  EDIT_TIME_ZONE: 'urn:replicon:user-action:edit-timezone',
  EDIT_DOCUMENTS: 'urn:replicon:user-action:edit-documents',
  VIEW_DOCUMENTS: 'urn:replicon:user-action:view-documents',
  VIEW_SKILL_ASSIGNMENTS: 'urn:replicon:user-action:view-skill-assignments',
  VIEW_SUPERVISOR: 'urn:replicon:user-action:view-supervisor'
};

export const USER_DAL = {
  PROJECT_MANAGER: 'urn:replicon:user-data-access-level:project-manager',
  RESOURCE_MANAGER: 'urn:replicon:user-data-access-level:resource-manager',
  RESOURCE_POOL_MANAGER:
    'urn:replicon:user-data-access-level:resource-pool-manager',
  SYSTEM_ADMINISTRATOR:
    'urn:replicon:user-data-access-level:administrative-data-access-scope',
  USER: 'urn:replicon:user-data-access-level:self'
};
